import RequestHelp_Wheel from '../Windows/RequestHelp/RequestHelp_Wheel';

/**
 * @author Sandra Koo
 * An extension of RequestHelp_Wheel for fail flow wheels
 */
export default class FailFlowWheel extends RequestHelp_Wheel {
  constructor(config) {
    super(config);

    this.pristinePrize = G.Utils.clone(this.prizeList.current);
  }

  init(config) {
    this.premium = config.premium;
    if (!this.premium) {
      this.premium = G.IAP ? G.IAP : false;
    }
    super.init();
  }

  makeWheelImage() {
    if (this.premium) {
      return super.makeWheelImage();
    }
    return G.makeImage(0, 0, 'prize_wheel_2', 0.5, null);
  }

  getIntendedDimensions(isCoin) {
    if (isCoin) {
      return 58.8;
    }
    return 80;
  }

  getLabelByPredeterminedPrize(index) {
    const prize = this.prizeList.current[index];
    for (let i = 0; i < this.labels.length; i++) {
      if (this.labels[i].prize === prize) {
        return this.labels[i];
      }
    }
    return null;
  }

  isWithinDeadSpot() {
    return true;
  }

  modifyBoosterChance(amount) {
    let boosterPack = null;
    for (let i = 0; i < this.prizeList.current.length; i++) {
      if (this.prizeList.current[i].prize.indexOf('booster') > -1) {
        boosterPack = this.prizeList.current[i];
      }
    }

    if (boosterPack != null) {
      boosterPack.chance += amount;
      this.updatePrizeList(this.prizeList);
    }
  }
}
